const REQUIRED_PROFILE_FIELDS = ['username', 'email', 'companyName', 'province', 'city']
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function isProfileComplete(profile) {
  if (!profile || typeof profile !== 'object') return false
  if (typeof profile.profileComplete === 'boolean') return profile.profileComplete

  // 兼容旧接口和表单校验；账号编号由系统生成，不属于用户填写项。
  return REQUIRED_PROFILE_FIELDS.every(field => (
    typeof profile[field] === 'string' && profile[field].trim().length > 0
  )) && EMAIL_PATTERN.test(profile.email.trim())
}

export function getProfilePathByRole(role) {
  if (role === 'ADMIN') return '/admin/profile'
  if (role === 'TEACHER') return '/teacher/profile'
  return '/student/profile'
}
